module.exports = __webpack_public_path__ + "img/sale1.png";